import React from 'react'
import {IUserList} from '../../../apis/user/getUserList'
import Text from '../../../components/text/Text'
import TableHeader from '../../../components/table/TableHeader'
import TableItem from '../../../components/table/TableItem'
import WizImage from '../../../components/image/WizImage'
import {useDisplayNumber} from '../../../utils/number'
import TableLayout from '../../../components/table/TableLayout'
import useNavigation from '../../../hooks/useNavigation'
import {useTime} from '../../../utils/time'
import {useImage} from '../../../utils/image'
import Span from '../../../components/text/Span'

interface IProps {
    className?: string
    data?: IUserList[]
}

const ProListTable: React.FC<IProps> = ({className, data}) => {
    const {floorBalance} = useDisplayNumber()
    const {goUserDetail} = useNavigation()
    const {convertUtc0ToUtc9} = useTime()
    const {renderThumbnail} = useImage()
    return (
        <div className={className}>
            <TableHeader className={'grid-cols-[1fr_250px_200px] md:grid-cols-[1fr_100px_100px] sm:hidden'}>
                <Text>Name</Text>
                <Text className={'md:hidden sm:block'}>Pro Until</Text>
                <Text className={'text-right sm:text-left'}>Total Balance</Text>
            </TableHeader>

            <TableLayout>
                {data?.map(item => (
                    <>
                        <TableItem
                            onClick={() => {
                                goUserDetail(item.id)
                            }}
                            key={item.id}
                            className={
                                'grid-cols-[1fr_250px_200px] md:grid-cols-[1fr_100px_100px] sm:grid-cols-1 sm:text-center sm:relative sm:pb-[70px]'
                            }>
                            <div
                                className={
                                    'flex items-center gap-x-[7px] sm:justify-center sm:flex-col sm:gap-y-[10px]'
                                }>
                                <div
                                    className={`${item?.is_pro && 'rounded-full border border-[2px] border-font_pro'}`}>
                                    <WizImage
                                        src={renderThumbnail(item.thumbnail)}
                                        className={'w-[40px] h-[40px] rounded-full'}
                                    />
                                </div>
                                <Text className={'hover:text-primary font-bold truncate sm:text-ti1'}>{item.name}</Text>
                                {item?.is_pro && (
                                    <div className={'bg-gradient_pro px-[5px] py-[1px] rounded-[3px]'}>
                                        <Text className={'text-ti3 text-white'}>PRO</Text>
                                    </div>
                                )}
                            </div>
                            <Text
                                className={
                                    'text-font02 md:hidden sm:block sm:absolute sm:bottom-[20px] sm:left-[50%] sm:translate-x-[-50%] sm:text-font03 sm:text-body3 sm:w-full'
                                }>
                                <Span className={'hidden sm:inline text-body3 text-font03'}>Create At : </Span>{' '}
                                {convertUtc0ToUtc9(item.pro_until)}
                            </Text>

                            <Text className={'text-right sm:text-center sm:text-ti2'}>
                                <Span className={'hidden sm:inline text-font02 text-body3'}>Balance : </Span>{' '}
                                {floorBalance(item?.usd_balance)}
                            </Text>
                        </TableItem>
                    </>
                ))}
            </TableLayout>
        </div>
    )
}

export default ProListTable
